import './MakeSkeleton.scss';

const MakeSkeleton = () => {

  return (
    <div className='home__make__section home__make__section__skeleton'>
      <div className='left__side__make__section left__side__make__section__skeleton'>
        <svg
          className="looking-for-bg"
          width="100%"
          height="100%"
          viewBox="0 0 400 400"
        >
          <defs>
            <linearGradient id="grad1" gradientTransform="rotate(-45)">
              <stop offset="0%" stopColor="#00385a" />
              <stop offset="45%" stopColor="#014976" />
              <stop offset="80%" stopColor="#00385a" />
            </linearGradient>
          </defs>
          <polygon points="0,0 800,0 700,600 0,600" fill="url(#grad1)" />
        </svg>
      </div>
      <div className='right__side__make__section right__side__make__section__skeleton'>
        <div className='make__title__skeleton'></div>
        <div className='make__subtitle__skeleton'></div>
        <div className='make__subtitle__skeleton--primary'></div>
        <div className='make__button__skeleton'></div>
      </div>
    </div>
  );
};

export default MakeSkeleton;